<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { GraduationCap, Globe } from 'lucide-vue-next'

import BaseIcon from '@/components/BaseIcon.vue'
import { useResume } from '@/composables/useResume'
import { onEnter } from '@/utils/onEnter'

const { content } = useResume()
const { t } = useI18n()

const education = computed(() => content.value.education)

const root = ref<HTMLElement | null>(null)
let cleanups: Array<() => void> = []

// Шкалы языков заполняются от 0 до своего pct при попадании в кадр.
onMounted(() => {
  if (root.value === null) return
  root.value.querySelectorAll<HTMLElement>('.lang-fill').forEach((fill) => {
    cleanups.push(onEnter(fill, () => {
      fill.style.width = `${fill.dataset.pct ?? '0'}%`
    }))
  })
})

onUnmounted(() => {
  cleanups.forEach((stop) => stop())
  cleanups = []
})
</script>

<template>
  <section id="education">
    <div ref="root" class="wrap">
      <div class="sec-head reveal">
        <div class="eyebrow"><span class="eyebrow-idx">04 /</span> {{ t('sections.backgroundEyebrow') }}</div>
        <h2 class="sec-title">{{ t('sections.eduLangTitle') }}</h2>
      </div>
      <div class="dual">
        <div class="panel glass reveal d1">
          <div class="panel-title"><span class="ic"><BaseIcon :icon="GraduationCap" :size="20" /></span>{{ content.sectionTitles.education }}</div>
          <div class="edu-school">{{ education.school }}</div>
          <div class="edu-meta">{{ education.period }}</div>
          <div class="edu-degree">{{ education.degree }}</div>
          <div class="edu-grade">{{ t('edu.grade') }} <span class="g">{{ education.grade }}</span></div>
        </div>
        <div class="panel glass reveal d2">
          <div class="panel-title"><span class="ic"><BaseIcon :icon="Globe" :size="20" /></span>{{ content.sectionTitles.languages }}</div>
          <div v-for="(lang, i) in content.languages" :key="i" class="lang-row">
            <div class="lang-top">
              <span class="lang-name">{{ lang.name }}</span>
              <span class="lang-level">{{ lang.level }}</span>
            </div>
            <div class="lang-bar"><div class="lang-fill" :data-pct="lang.pct"></div></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
